import React, { FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '../ui/Typography'
import { ButtonRegular } from '../ui/Button'
import { colors } from '../styles/colors'
import VoteIoSuccess from '../svgr/VoteIoSuccess'
import { DialogCloseButton } from '../components/DialogCloseButton'

export const VoteSuccessfullyAccepted: FC<{
  amountToVote: number
  onClose?: () => void
  toMainPage: () => void
  onViewMyVotedBoxes: () => void
}> = ({ onViewMyVotedBoxes, toMainPage, onClose, amountToVote }) => {
  return (
    <DialogContainer>
      {onClose && <DialogCloseButton onClick={onClose} />}

      <IconContainer>
        <VoteIoSuccess />
      </IconContainer>

      <ContentContainer>
        <TitleContainer>
          <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
            <FormattedMessage
              id="dialog.voteSuccessfullyAccepted.title"
              defaultMessage="Ваш голос успешно принят"
            />
          </Typography>
        </TitleContainer>

        <DescriptionContainer>
          <Typography
            fontSize={14}
            fontWeight={400}
            color={colors.secondary}
            font="roboto"
          >
            <FormattedMessage
              id="dialog.voteSuccessfullyAccepted.description"
              defaultMessage="Подтверждение может занять некоторое время"
            />
          </Typography>
        </DescriptionContainer>
      </ContentContainer>

      <VoteAmountContainer>
        <Typography fontSize={14} fontWeight={400} color={colors.grey800}>
          <FormattedMessage
            id="dialog.voteSuccessfullyAccepted.voteAmount"
            defaultMessage="Ваш голос"
          />
        </Typography>

        <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
          {amountToVote} TON
        </Typography>
      </VoteAmountContainer>

      <ButtonsContainer>
        <PrimaryButton
          onClick={onViewMyVotedBoxes}
          textColor={colors.white}
          textWeight={700}
        >
          <FormattedMessage
            id="dialog.voteSuccessfullyAccepted.myVotes"
            defaultMessage="Мои голоса"
          />
        </PrimaryButton>

        <SecondaryButton onClick={toMainPage}>
          <FormattedMessage
            id="dialog.voteSuccessfullyAccepted.goToMain"
            defaultMessage="На главную"
          />
        </SecondaryButton>
      </ButtonsContainer>
    </DialogContainer>
  )
}

export const voteSuccessfullyAcceptedPath = '/vote-successfully-accepted'

const DialogContainer = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  gap: 48px;
  background: ${colors.bgPrimary};
  border-radius: 20px;
  padding: 48px 32px;
  width: 100%;
  max-width: 400px;
  text-align: center;
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 120px;
    height: auto;
  }
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
  max-width: 250px;
`

const ButtonsContainer = styled.div`
  width: 100%;
  max-width: 280px;
  display: grid;
  gap: 12px;
`

const PrimaryButton = styled(ButtonRegular)`
  width: 100%;
  background: ${colors.secondary};
  color: ${colors.white};
`

const SecondaryButton = styled(ButtonRegular)`
  width: 100%;
  background: transparent;
  border: 1px solid ${colors.borderPrimary};
  color: ${colors.textPrimary};
`

const VoteAmountContainer = styled.div`
  display: grid;
  gap: 8px;
`
